<script setup lang="ts">
import type {EverDetailInfo} from '@/types';

const props = defineProps({
  modelValue: {
    type: Object as PropType<EverDetailInfo>,
    required: true,
  },
});

const emit = defineEmits(['update:model-value']);

const formModel = ref<EverDetailInfo>({...props.modelValue});

const validationError = ref(false);
const eventTypeComponent = ref();
const dateTimeSelectComponent = ref();
const numberGuestsComponent = ref();

function validate(): boolean {
  if (!eventTypeComponent.value.validate() || !dateTimeSelectComponent.value.validate() || !numberGuestsComponent.value.validate()) {
    validationError.value = true;
    return false;
  }

  emit('update:model-value', formModel.value);
  return true;
}

defineExpose({validate});
</script>

<template>
  <h1>Reserve your Celebration</h1>
  <div class="event-selector">
    <div class="event-selector-row">
      <!-- Select type of event -->
      <EverFormEventType ref="eventTypeComponent" v-model="formModel.eventType" @update:model-value="(type) => (formModel.eventType = type)" />

      <!-- Select date and time -->
      <div class="date-time-container">
        <EverFormDateTimeSelect ref="dateTimeSelectComponent" v-model="formModel.dates" :validation-error="true" @update:model-value="(dates) => (formModel.dates = dates)" />
        <EverFormNumberGuests ref="numberGuestsComponent" v-model="formModel.numberGuests" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/scss/queries';

.event-selector {
  display: flex;
  flex-direction: column;
  gap: 6rem;
  width: 100%;

  h3 {
    color: black;
    font-size: 2rem;
    font-weight: 700;
    margin: 0;
    text-align: left;
    text-transform: none;

    @include queries.for-size(phone) {
      font-size: 2.5rem;
      margin: 0;
    }
  }

  h4 {
    font-size: 1.4rem;
    margin: 0 0 1.5rem 0;
  }

  p {
    color: #9a9999;
    font-size: 1.3rem;
    text-align: center;

    @include queries.for-size(phone) {
      font-size: 2.25rem;
    }
  }

  ul {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 2rem;
    justify-content: space-between;
    list-style-type: none;
    margin: 0;
    padding: 0;

    li {
      @include queries.for-size(phone) {
        padding: 0.2rem 0;
      }
    }
  }

  .event-selector-row {
    display: grid;
    gap: 4rem;
    grid-template-columns: 30% 70%;

    @include queries.for-size(ipadpro-portrait-down) {
      grid-template-columns: 1fr;
      padding: 0.2rem;
    }

    > div {
      h3 {
        margin-bottom: 3rem;
      }
    }

    .select-event-type {
      flex: 1;
    }
  }

  @include queries.for-size(phone) {
    flex-direction: column;
    gap: 2rem;
  }
}
</style>
